'use strict';

const conflictStates = ({ elm }) => {
	return [
		elm({
			name: 'site.ConflictsTrustpilotUpload',
			moduleName: 'Network.Conflicts.Trustpilot.Upload.Main',
			url: '/conflicts/trustpilot/upload',
			requiredPermission: 'role/customersuccess',
			pageTitle: 'listings.navigation.conflicts_trustpilot_upload'
		}),
		{
			name: 'site.ConflictsBrandpageFacebook',
			url: '/conflicts/facebook/brandpage',
			templateUrl: 'components/conflicts/facebook/brandpage/conflictsView.html',
			controller: 'BrandPageConflictsFacebookCtrl',
			requiredPermission: 'role/owner'
		},
		{
			name: 'site.ConflictsResolver',
			url: '/conflicts/resolve',
			component: 'pmtConflictResolver',
			requiredPermission: 'permission/task.conflict.manage'
		}
	];
};

module.exports = {
	conflictStates
};
